module.exports = __webpack_public_path__ + "img/logo-2026.d84872a.svg";